import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// 🔥 Desactivar consola SI estamos en producción
if (environment.production) {
  enableProdMode();

  // 🛑 Lógica para deshabilitar completamente la consola en producción
  if (window) {
    // Incluye todos los métodos que quieres silenciar, incluyendo 'error'
    const methods = ['log', 'debug', 'warn', 'info', 'table', 'clear', 'error'];
    
    methods.forEach(method => {
      // Reemplaza el método nativo de la consola con una función vacía
      (window.console as any)[method] = function() {};
    });
  }

}

document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => {
      // Esto ya no mostrará nada porque console.error ya está vacío en producción
      console.error(err);
    });
});
